/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CSSTransition from 'react-transition-group/CSSTransition';

class WrapperPopUp extends Component {
  handleClose = event => {
    if (event) {
      event.preventDefault();
    }
    this.props.handleClose();
  };

  render() {
    return (
      <CSSTransition
        in={this.props.in}
        classNames=""
        timeout={500}
        unmountOnExit
        onEnter={() => {
          // eslint-disable-next-line no-undef
          $(`#${this.props.elementId}`).modal('show');
        }}
        onExiting={() => {
          // eslint-disable-next-line no-undef
          $(`#${this.props.elementId}`).modal('hide');
        }}
        onExited={() => {
          // eslint-disable-next-line no-undef
          this.setState({
            hasShow: false
          });
        }}
      >
        <div
          key={this.props.elementId}
          id={this.props.elementId}
          className="modal modal-gray fade"
          role="dialog"
          tabIndex="-1"
          onClick={this.handleClose}
        >
          {this.props.children}
        </div>
      </CSSTransition>
    );
  }
}

WrapperPopUp.defaultProps = {
  elementId: 'wrapperPopUp',
  children: null
};

WrapperPopUp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),

  // IN
  in: PropTypes.bool.isRequired,
  elementId: PropTypes.string,
  handleClose: PropTypes.func.isRequired
};

export default WrapperPopUp;



// WEBPACK FOOTER //
// ./src/components/Common/PopUps/WrapperPopUp/WrapperPopUp.js